import { SearchParameters, SignInResponse } from "@/types";

const KEY_SEARCH_PARAMETERS = "searchParameters";
const KEY_USER = "user";

export const storage = {
  clear: () => {
    localStorage.clear();
  },

  // Search Parameters //
  getSearchParameters: (): SearchParameters | null => {
    const searchParameters = localStorage.getItem(KEY_SEARCH_PARAMETERS);
    if (!searchParameters) return null;

    // TODO: Better way to verify type.
    return JSON.parse(searchParameters) as SearchParameters;
  },
  setSearchParameters: (searchParameters: SearchParameters) => {
    localStorage.setItem(
      KEY_SEARCH_PARAMETERS,
      JSON.stringify(searchParameters),
    );
  },

  // User //
  getUser: (): SignInResponse | null => {
    const user = localStorage.getItem(KEY_USER);
    if (!user) return null;

    // TODO: Better way to verify type.
    return JSON.parse(user) as SignInResponse;
  },
  setUser: (user: SignInResponse) => {
    localStorage.setItem(KEY_USER, JSON.stringify(user));
  },
};
